module.exports = __webpack_public_path__ + "img/SWMTreasureFish_EGM.b6f68ebe.jpg";